import IdentitySelectorOptionDraggable from './draggable';

export default IdentitySelectorOptionDraggable;
